// // // pages/assessment/AssessmentReport.jsx
// // import { useState, useEffect, useContext } from "react";
// // import axios from "axios";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   TextField,
// //   MenuItem,
// //   CircularProgress,
// //   Alert,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Chip,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import { useATS } from "../atsModule/context/ATSContext";
// // import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // const AssessmentReport = () => {
// //   const { store_id } = useATS();
// //   const contextData = useContext(AutoTaskAuthContext);
// //   const { allUsers } = contextData; // array of all users from context

// //   const [assignments, setAssignments] = useState([]);
// //   const [assessments, setAssessments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [selectedUserId, setSelectedUserId] = useState("");
// //   const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
// //   const [submitLoading, setSubmitLoading] = useState(false);
// //   const [filterUserId, setFilterUserId] = useState("");
// //   const [filterStatus, setFilterStatus] = useState("");

// //   // Filter users belonging to this store (if your allUsers contains users from multiple stores)
// //   const staffUsers =
// //     allUsers?.filter((user) => user.store_id === store_id) || [];

// //   const fetchData = async () => {
// //     if (store_id === undefined || store_id === null) return;
// //     try {
// //       setLoading(true);
// //       // Fetch assignments
// //       const assignmentsRes = await axios.get(
// //         `${API_BASE}/api/assessment/user-assessments`,
// //         {
// //           params: {
// //             store_id,
// //             user_id: filterUserId || undefined,
// //             status: filterStatus || undefined,
// //           },
// //         },
// //       );
// //       setAssignments(assignmentsRes.data.data || []);

// //       // Fetch all assessments (from folders)
// //       const foldersRes = await axios.get(
// //         `${API_BASE}/api/assessment/assessment-folders`,
// //         { params: { store_id } },
// //       );
// //       const folders = foldersRes.data.data || [];
// //       let allAssessments = [];
// //       for (const folder of folders) {
// //         const assessmentsRes = await axios.get(
// //           `${API_BASE}/api/assessment/assessments/folder/${folder.id}`,
// //           { params: { store_id } },
// //         );
// //         allAssessments = [
// //           ...allAssessments,
// //           ...(assessmentsRes.data.data || []),
// //         ];
// //       }
// //       setAssessments(allAssessments);
// //       setError("");
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load data");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [store_id, filterUserId, filterStatus]);

// //   const handleAssign = async () => {
// //     if (!selectedUserId || !selectedAssessmentId) {
// //       alert("Please select both user and assessment");
// //       return;
// //     }
// //     setSubmitLoading(true);
// //     try {
// //       await axios.post(`${API_BASE}/api/assessment/user-assessments`, {
// //         store_id,
// //         user_id: selectedUserId,
// //         assessment_id: selectedAssessmentId,
// //       });
// //       alert("Assessment assigned successfully");
// //       setModalOpen(false);
// //       setSelectedUserId("");
// //       setSelectedAssessmentId("");
// //       fetchData();
// //     } catch (err) {
// //       console.error(err);
// //       alert(err.response?.data?.statusMessage || "Failed to assign");
// //     } finally {
// //       setSubmitLoading(false);
// //     }
// //   };

// //   const handleRevoke = async (assignmentId) => {
// //     if (!window.confirm("Revoke this assignment?")) return;
// //     try {
// //       await axios.delete(
// //         `${API_BASE}/api/assessment/user-assessments/${assignmentId}`,
// //         { data: { store_id } },
// //       );
// //       fetchData();
// //     } catch (err) {
// //       alert("Failed to revoke");
// //     }
// //   };

// //   if (loading)
// //     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
// //   if (error) return <Alert severity="error">{error}</Alert>;

// //   return (
// //     <Box>
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           mb: 3,
// //         }}
// //       >
// //         <Typography variant="h4" fontWeight={600}>
// //           Assessment Assignments & Report
// //         </Typography>
// //         <Button
// //           variant="contained"
// //           startIcon={<AddIcon />}
// //           onClick={() => setModalOpen(true)}
// //           sx={{ bgcolor: "#1a2a3a" }}
// //         >
// //           Assign Assessment
// //         </Button>
// //       </Box>

// //       {/* Filters */}
// //       <Paper sx={{ p: 2, mb: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
// //         <TextField
// //           select
// //           label="Filter by User"
// //           value={filterUserId}
// //           onChange={(e) => setFilterUserId(e.target.value)}
// //           sx={{ minWidth: 200 }}
// //         >
// //           <MenuItem value="">All Users</MenuItem>
// //           {staffUsers.map((user) => (
// //             <MenuItem key={user.id} value={user.id}>
// //               {user.name} ({user.email})
// //             </MenuItem>
// //           ))}
// //         </TextField>
// //         <TextField
// //           select
// //           label="Filter by Status"
// //           value={filterStatus}
// //           onChange={(e) => setFilterStatus(e.target.value)}
// //           sx={{ minWidth: 150 }}
// //         >
// //           <MenuItem value="">All</MenuItem>
// //           <MenuItem value="PENDING">Pending</MenuItem>
// //           <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
// //           <MenuItem value="COMPLETED">Completed</MenuItem>
// //         </TextField>
// //         <Button
// //           variant="outlined"
// //           onClick={() => {
// //             setFilterUserId("");
// //             setFilterStatus("");
// //           }}
// //         >
// //           Clear Filters
// //         </Button>
// //       </Paper>

// //       {/* Assignments Table */}
// //       <TableContainer component={Paper}>
// //         <Table>
// //           <TableHead>
// //             <TableRow>
// //               <TableCell>User</TableCell>
// //               <TableCell>Assessment</TableCell>
// //               <TableCell>Status</TableCell>
// //               <TableCell>Score</TableCell>
// //               <TableCell>Assigned Date</TableCell>
// //               <TableCell>Submitted Date</TableCell>
// //               <TableCell>Actions</TableCell>
// //             </TableRow>
// //           </TableHead>
// //           <TableBody>
// //             {assignments.length === 0 ? (
// //               <TableRow>
// //                 <TableCell colSpan={7} align="center">
// //                   No assignments found
// //                 </TableCell>
// //               </TableRow>
// //             ) : (
// //               assignments.map((ass) => (
// //                 <TableRow key={ass.id}>
// //                   <TableCell>
// //                     {ass.user?.name || `User ID: ${ass.user_id}`}
// //                   </TableCell>
// //                   <TableCell>
// //                     {ass.Assessment?.title ||
// //                       `Assessment ID: ${ass.assessment_id}`}
// //                   </TableCell>
// //                   <TableCell>
// //                     <Chip
// //                       label={ass.status}
// //                       color={ass.status === "COMPLETED" ? "success" : "warning"}
// //                       size="small"
// //                     />
// //                   </TableCell>
// //                   <TableCell>
// //                     {ass.score !== null
// //                       ? `${ass.score}/${ass.Assessment?.max_score || 0}`
// //                       : "Not taken"}
// //                   </TableCell>
// //                   <TableCell>
// //                     {new Date(ass.assigned_at).toLocaleDateString()}
// //                   </TableCell>
// //                   <TableCell>
// //                     {ass.submitted_at
// //                       ? new Date(ass.submitted_at).toLocaleDateString()
// //                       : "-"}
// //                   </TableCell>
// //                   <TableCell>
// //                     <Button
// //                       size="small"
// //                       color="error"
// //                       onClick={() => handleRevoke(ass.id)}
// //                       startIcon={<DeleteIcon />}
// //                     >
// //                       Revoke
// //                     </Button>
// //                   </TableCell>
// //                 </TableRow>
// //               ))
// //             )}
// //           </TableBody>
// //         </Table>
// //       </TableContainer>

// //       {/* Assign Modal */}
// //       <Dialog
// //         open={modalOpen}
// //         onClose={() => setModalOpen(false)}
// //         maxWidth="sm"
// //         fullWidth
// //       >
// //         <DialogTitle>Assign Assessment to Staff</DialogTitle>
// //         <DialogContent>
// //           <TextField
// //             select
// //             label="Select User"
// //             fullWidth
// //             margin="dense"
// //             value={selectedUserId}
// //             onChange={(e) => setSelectedUserId(e.target.value)}
// //           >
// //             <MenuItem value="">Select a user</MenuItem>
// //             {staffUsers.map((user) => (
// //               <MenuItem key={user.id} value={user.id}>
// //                 {user.name} ({user.email})
// //               </MenuItem>
// //             ))}
// //           </TextField>
// //           <TextField
// //             select
// //             label="Select Assessment"
// //             fullWidth
// //             margin="dense"
// //             value={selectedAssessmentId}
// //             onChange={(e) => setSelectedAssessmentId(e.target.value)}
// //           >
// //             <MenuItem value="">Select an assessment</MenuItem>
// //             {assessments.map((ass) => (
// //               <MenuItem key={ass.id} value={ass.id}>
// //                 {ass.title} (Folder: {ass.folder_id})
// //               </MenuItem>
// //             ))}
// //           </TextField>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setModalOpen(false)}>Cancel</Button>
// //           <Button
// //             onClick={handleAssign}
// //             variant="contained"
// //             disabled={submitLoading}
// //           >
// //             {submitLoading ? <CircularProgress size={24} /> : "Assign"}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default AssessmentReport;
// // pages/assessment/AssessmentReport.jsx
// import { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   MenuItem,
//   CircularProgress,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Chip,
//   IconButton,
//   Tooltip,
//   Skeleton,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import AssignmentIcon from "@mui/icons-material/Assignment";
// import PeopleIcon from "@mui/icons-material/People";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import { useATS } from "../atsModule/context/ATSContext";
// import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // Blue palette (consistent with other components)
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   900: "#1e3a8a",
// };

// // Keyframes injection
// const KF_ID = "fa-keyframes-report";
// if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
//   const style = document.createElement("style");
//   style.id = KF_ID;
//   style.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
//     @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
//     @keyframes float   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
//   `;
//   document.head.appendChild(style);
// }

// const fontFam = "'Plus Jakarta Sans', sans-serif";

// const primaryBtnSx = {
//   color: "#fff",
//   borderRadius: "11px",
//   px: 2.5,
//   py: 1,
//   fontFamily: fontFam,
//   fontWeight: 600,
//   boxShadow: `0 4px 14px ${BLUE[200]}`,
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: `0 8px 22px ${BLUE[300]}`,
//     background: `linear-gradient(135deg, ${BLUE[700]} 0%, ${BLUE[900]} 100%)`,
//   },
//   transition: "all 0.2s ease",
// };

// const outlineBtnSx = {
//   borderRadius: "10px",
//   fontFamily: fontFam,
//   fontWeight: 500,
//   borderColor: "#cbd5e1",
//   color: "#475569",
//   "&:hover": {
//     borderColor: BLUE[400],
//     backgroundColor: BLUE[50],
//     color: BLUE[600],
//   },
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     fontFamily: fontFam,
//     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BLUE[400] },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: BLUE[600],
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": { color: BLUE[600] },
// };

// const AssessmentReport = () => {
//   const { store_id } = useATS();
//   const contextData = useContext(AutoTaskAuthContext);
//   const { allUsers } = contextData;

//   const [assignments, setAssignments] = useState([]);
//   const [assessments, setAssessments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState("");
//   const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [filterUserId, setFilterUserId] = useState("");
//   const [filterStatus, setFilterStatus] = useState("");

//   const staffUsers =
//     allUsers?.filter((user) => user.store_id === store_id) || [];

//   const fetchData = async () => {
//     if (store_id === undefined || store_id === null) return;
//     try {
//       setLoading(true);
//       const assignmentsRes = await axios.get(
//         `${API_BASE}/api/assessment/user-assessments`,
//         {
//           params: {
//             store_id,
//             user_id: filterUserId || undefined,
//             status: filterStatus || undefined,
//           },
//         },
//       );
//       setAssignments(assignmentsRes.data.data || []);

//       const foldersRes = await axios.get(
//         `${API_BASE}/api/assessment/assessment-folders`,
//         { params: { store_id } },
//       );
//       const folders = foldersRes.data.data || [];
//       let allAssessments = [];
//       for (const folder of folders) {
//         const assessmentsRes = await axios.get(
//           `${API_BASE}/api/assessment/assessments/folder/${folder.id}`,
//           { params: { store_id } },
//         );
//         allAssessments = [
//           ...allAssessments,
//           ...(assessmentsRes.data.data || []),
//         ];
//       }
//       setAssessments(allAssessments);
//       setError("");
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [store_id, filterUserId, filterStatus]);

//   const handleAssign = async () => {
//     if (!selectedUserId || !selectedAssessmentId) {
//       alert("Please select both user and assessment");
//       return;
//     }
//     setSubmitLoading(true);
//     try {
//       await axios.post(`${API_BASE}/api/assessment/user-assessments`, {
//         store_id,
//         user_id: selectedUserId,
//         assessment_id: selectedAssessmentId,
//       });
//       alert("Assessment assigned successfully");
//       setModalOpen(false);
//       setSelectedUserId("");
//       setSelectedAssessmentId("");
//       fetchData();
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.statusMessage || "Failed to assign");
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const handleRevoke = async (assignmentId) => {
//     if (!window.confirm("Revoke this assignment?")) return;
//     try {
//       await axios.delete(
//         `${API_BASE}/api/assessment/user-assessments/${assignmentId}`,
//         { data: { store_id } },
//       );
//       fetchData();
//     } catch (err) {
//       alert("Failed to revoke");
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           background: "#f8fafc",
//           fontFamily: fontFam,
//           p: { xs: 2, sm: 4 },
//         }}
//       >
//         <Box sx={{ mb: 3 }}>
//           <Skeleton variant="rounded" width="40%" height={42} sx={{ mb: 2 }} />
//           <Skeleton variant="rounded" width="30%" height={24} />
//         </Box>
//         <Skeleton variant="rounded" width="100%" height={120} sx={{ mb: 3 }} />
//         <Skeleton variant="rounded" width="100%" height={400} />
//       </Box>
//     );
//   }
//   if (error)
//     return (
//       <Alert severity="error" sx={{ m: 3 }}>
//         {error}
//       </Alert>
//     );

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: fontFam,
//         p: { xs: 2, sm: 4 },
//       }}
//     >
//       {/* Quote Banner */}
//       <Box
//         sx={{
//           mb: 4,
//           p: "13px 20px",
//           borderRadius: "14px",
//           background: "#0c8a9b",
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           animation: "fadeUp 0.4s ease both",
//           boxShadow: `0 4px 18px ${BLUE[200]}`,
//         }}
//       >
//         <AutoAwesomeIcon
//           sx={{ color: "#fde68a", fontSize: 18, flexShrink: 0 }}
//         />
//         <Typography
//           sx={{
//             color: "#fff",
//             fontSize: "0.82rem",
//             fontWeight: 500,
//             fontStyle: "italic",
//             fontFamily: fontFam,
//           }}
//         >
//           "What gets measured gets managed."
//         </Typography>
//       </Box>

//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 4,
//           flexWrap: "wrap",
//           gap: 2,
//           animation: "fadeUp 0.45s ease both",
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 800,
//               fontFamily: fontFam,
//               color: "#0f172a",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             Assessment Assignments & Report
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//             Manage assignments and track completion
//           </Typography>
//         </Box>
//         <Button
//           startIcon={<AddIcon />}
//           onClick={() => setModalOpen(true)}
//           sx={{ ...primaryBtnSx, bgcolor: "#0c8a9b" }}
//         >
//           Assign Assessment
//         </Button>
//       </Box>

//       {/* Filters */}
//       <Paper
//         sx={{
//           p: 2.5,
//           mb: 4,
//           borderRadius: "20px",
//           background: "#fff",
//           boxShadow: "0 4px 20px rgba(0,0,0,.05)",
//           animation: "fadeUp 0.5s ease both",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 2,
//             alignItems: "center",
//           }}
//         >
//           <TextField
//             select
//             label="Filter by User"
//             value={filterUserId}
//             onChange={(e) => setFilterUserId(e.target.value)}
//             sx={{ minWidth: 220 }}
//             size="small"
//             InputProps={{ sx: { borderRadius: "10px" } }}
//           >
//             <MenuItem value="">All Users</MenuItem>
//             {staffUsers.map((user) => (
//               <MenuItem key={user.id} value={user.id}>
//                 {user.name} ({user.email})
//               </MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             select
//             label="Filter by Status"
//             value={filterStatus}
//             onChange={(e) => setFilterStatus(e.target.value)}
//             sx={{ minWidth: 160 }}
//             size="small"
//             InputProps={{ sx: { borderRadius: "10px" } }}
//           >
//             <MenuItem value="">All</MenuItem>
//             <MenuItem value="PENDING">Pending</MenuItem>
//             <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
//             <MenuItem value="COMPLETED">Completed</MenuItem>
//           </TextField>
//           <Button
//             variant="outlined"
//             onClick={() => {
//               setFilterUserId("");
//               setFilterStatus("");
//             }}
//             sx={outlineBtnSx}
//           >
//             Clear Filters
//           </Button>
//           <Tooltip title="Refresh data">
//             <IconButton onClick={fetchData} sx={{ color: BLUE[500] }}>
//               <RefreshIcon />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       </Paper>

//       {/* Assignments Table */}
//       <TableContainer
//         component={Paper}
//         sx={{
//           borderRadius: "20px",
//           overflow: "hidden",
//           boxShadow: "0 4px 20px rgba(0,0,0,.05)",
//           animation: "fadeUp 0.55s ease both",
//         }}
//       >
//         <Table>
//           <TableHead
//             sx={{
//               backgroundColor: "#f8fafc",
//               borderBottom: "2px solid #e2e8f0",
//             }}
//           >
//             <TableRow>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 User
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Assessment
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Status
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Score
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Assigned Date
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Submitted Date
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700, fontFamily: fontFam }}>
//                 Actions
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {assignments.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
//                   <Typography
//                     variant="body1"
//                     color="text.secondary"
//                     fontFamily={fontFam}
//                   >
//                     No assignments found.
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               assignments.map((ass, idx) => (
//                 <TableRow
//                   key={ass.id}
//                   sx={{
//                     transition: "background 0.2s",
//                     "&:hover": { backgroundColor: "#fafcff" },
//                     animation: `fadeUp 0.4s ease ${idx * 0.03}s both`,
//                   }}
//                 >
//                   <TableCell sx={{ fontFamily: fontFam }}>
//                     {ass.user?.name || `User ID: ${ass.user_id}`}
//                   </TableCell>
//                   <TableCell sx={{ fontFamily: fontFam }}>
//                     {ass.Assessment?.title ||
//                       `Assessment ID: ${ass.assessment_id}`}
//                   </TableCell>
//                   <TableCell>
//                     <Chip
//                       label={ass.status}
//                       size="small"
//                       sx={{
//                         fontFamily: fontFam,
//                         fontWeight: 600,
//                         backgroundColor:
//                           ass.status === "COMPLETED" ? "#f0fdf4" : "#fffbeb",
//                         color:
//                           ass.status === "COMPLETED" ? "#16a34a" : "#d97706",
//                         borderRadius: "8px",
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell sx={{ fontFamily: fontFam, fontWeight: 500 }}>
//                     {ass.score !== null
//                       ? `${ass.score}/${ass.Assessment?.max_score || 0}`
//                       : "Not taken"}
//                   </TableCell>
//                   <TableCell sx={{ fontFamily: fontFam }}>
//                     {new Date(ass.assigned_at).toLocaleDateString()}
//                   </TableCell>
//                   <TableCell sx={{ fontFamily: fontFam }}>
//                     {ass.submitted_at
//                       ? new Date(ass.submitted_at).toLocaleDateString()
//                       : "-"}
//                   </TableCell>
//                   <TableCell>
//                     <Button
//                       size="small"
//                       variant="outlined"
//                       color="error"
//                       onClick={() => handleRevoke(ass.id)}
//                       startIcon={<DeleteIcon />}
//                       sx={{
//                         borderRadius: "8px",
//                         textTransform: "none",
//                         fontFamily: fontFam,
//                         borderColor: "#fecaca",
//                         "&:hover": {
//                           backgroundColor: "#fef2f2",
//                           borderColor: "#ef4444",
//                         },
//                       }}
//                     >
//                       Revoke
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Assign Modal */}
//       <Dialog
//         open={modalOpen}
//         onClose={() => setModalOpen(false)}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "20px",
//             boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
//             overflow: "hidden",
//             fontFamily: fontFam,
//           },
//         }}
//       >
//         <Box
//           sx={{
//             height: 6,
//             background: `linear-gradient(90deg, ${BLUE[500]} 0%, ${BLUE[700]} 100%)`,
//           }}
//         />
//         <DialogTitle
//           sx={{
//             fontFamily: fontFam,
//             fontWeight: 700,
//             fontSize: "1.2rem",
//             color: "#0f172a",
//             pt: 3,
//           }}
//         >
//           Assign Assessment to Staff
//         </DialogTitle>
//         <DialogContent sx={{ pt: 1 }}>
//           <TextField
//             select
//             label="Select User"
//             fullWidth
//             margin="dense"
//             value={selectedUserId}
//             onChange={(e) => setSelectedUserId(e.target.value)}
//             sx={{ ...inputSx, mb: 2 }}
//           >
//             <MenuItem value="">Select a user</MenuItem>
//             {staffUsers.map((user) => (
//               <MenuItem key={user.id} value={user.id}>
//                 {user.name} ({user.email})
//               </MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             select
//             label="Select Assessment"
//             fullWidth
//             margin="dense"
//             value={selectedAssessmentId}
//             onChange={(e) => setSelectedAssessmentId(e.target.value)}
//             sx={inputSx}
//           >
//             <MenuItem value="">Select an assessment</MenuItem>
//             {assessments.map((ass) => (
//               <MenuItem key={ass.id} value={ass.id}>
//                 {ass.title} (Folder: {ass.folder_id})
//               </MenuItem>
//             ))}
//           </TextField>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             onClick={() => setModalOpen(false)}
//             sx={{
//               fontFamily: fontFam,
//               fontWeight: 600,
//               color: "#64748b",
//               borderRadius: "10px",
//               "&:hover": { background: "#f1f5f9" },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleAssign}
//             variant="contained"
//             disabled={submitLoading}
//             sx={primaryBtnSx}
//           >
//             {submitLoading ? (
//               <CircularProgress size={24} sx={{ color: "#fff" }} />
//             ) : (
//               "Assign"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AssessmentReport;
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  IconButton,
  Tooltip,
  Skeleton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useATS } from "../atsModule/context/ATSContext";
import { AutoTaskAuthContext } from "../../Context/AutoTaskContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const TEAL = "#0c8a9b";
const FONT = "'DM Sans', 'Inter', sans-serif";

const KF_ID = "ar-kf";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const s = document.createElement("style");
  s.id = KF_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  `;
  document.head.appendChild(s);
}

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: FONT,
    fontSize: "0.875rem",
    background: "#fff",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: TEAL },
};

const STATUS_STYLE = {
  PENDING: { label: "Pending", bg: "#fff8e1", color: "#d97706" },
  IN_PROGRESS: { label: "In Progress", bg: "#e6f6f8", color: TEAL },
  COMPLETED: { label: "Completed", bg: "#f0fdf4", color: "#16a34a" },
};

const AssessmentReport = () => {
  const { store_id } = useATS();
  const contextData = useContext(AutoTaskAuthContext);
  const { allUsers } = contextData;

  const [assignments, setAssignments] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filterUserId, setFilterUserId] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  const staffUsers =
    allUsers?.filter((user) => user.store_id === store_id) || [];

  const fetchData = async () => {
    if (store_id === undefined || store_id === null) return;
    try {
      setLoading(true);
      const assignmentsRes = await axios.get(
        `${API_BASE}/api/assessment/user-assessments`,
        {
          params: {
            store_id,
            user_id: filterUserId || undefined,
            status: filterStatus || undefined,
          },
        },
      );
      setAssignments(assignmentsRes.data.data || []);

      const foldersRes = await axios.get(
        `${API_BASE}/api/assessment/assessment-folders`,
        { params: { store_id } },
      );
      const folders = foldersRes.data.data || [];
      let allAssessments = [];
      for (const folder of folders) {
        const assessmentsRes = await axios.get(
          `${API_BASE}/api/assessment/assessments/folder/${folder.id}`,
          { params: { store_id } },
        );
        allAssessments = [
          ...allAssessments,
          ...(assessmentsRes.data.data || []),
        ];
      }
      setAssessments(allAssessments);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [store_id, filterUserId, filterStatus]);

  const handleAssign = async () => {
    if (!selectedUserId || !selectedAssessmentId) {
      alert("Please select both user and assessment");
      return;
    }
    setSubmitLoading(true);
    try {
      await axios.post(`${API_BASE}/api/assessment/user-assessments`, {
        store_id,
        user_id: selectedUserId,
        assessment_id: selectedAssessmentId,
      });
      alert("Assessment assigned successfully");
      setModalOpen(false);
      setSelectedUserId("");
      setSelectedAssessmentId("");
      fetchData();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.statusMessage || "Failed to assign");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleRevoke = async (assignmentId) => {
    if (!window.confirm("Revoke this assignment?")) return;
    try {
      await axios.delete(
        `${API_BASE}/api/assessment/user-assessments/${assignmentId}`,
        { data: { store_id } },
      );
      fetchData();
    } catch (err) {
      alert("Failed to revoke");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        borderRadius: 0.4,
        background: "#f8f9fa",
        fontFamily: FONT,
        p: { xs: 2, sm: 3.5 },
      }}
    >
      {/* ── Header ──────────────────────────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 3.5,
          animation: "fadeUp .4s ease both",
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: FONT,
              color: "#1a1d23",
              fontSize: "1.65rem",
              letterSpacing: "-0.3px",
            }}
          >
            Assessment Report
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#868e96",
              mt: 0.4,
              fontFamily: FONT,
              fontSize: "0.875rem",
            }}
          >
            Manage assignments and track completion
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: "16px !important" }} />}
          onClick={() => setModalOpen(true)}
          sx={{
            background: TEAL,
            color: "#fff",
            borderRadius: "10px",
            px: 2,
            py: 0.9,
            fontFamily: FONT,
            fontWeight: 600,
            fontSize: "0.85rem",
            textTransform: "none",
            boxShadow: "none",
            "&:hover": { background: "#0a7a8a", boxShadow: "none" },
          }}
        >
          Assign Assessment
        </Button>
      </Box>

      {error && (
        <Alert
          severity="error"
          sx={{ borderRadius: "12px", mb: 3, fontFamily: FONT }}
        >
          {error}
        </Alert>
      )}

      {/* ── Filter bar ───────────────────────────────────────────────── */}
      <Paper
        sx={{
          borderRadius: "14px",
          p: 2,
          mb: 3,
          boxShadow: "0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04)",
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          alignItems: "center",
          animation: "fadeUp .42s ease both",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.8,
            color: "#868e96",
          }}
        >
          <FilterAltOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography
            sx={{
              fontFamily: FONT,
              fontSize: "0.85rem",
              fontWeight: 500,
              color: "#495057",
            }}
          >
            Filters
          </Typography>
        </Box>
        <TextField
          select
          label="Filter by User"
          value={filterUserId}
          onChange={(e) => setFilterUserId(e.target.value)}
          sx={{ ...inputSx, minWidth: 200 }}
          size="small"
        >
          <MenuItem value="">All Users</MenuItem>
          {staffUsers.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name} ({user.email})
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="Filter by Status"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          sx={{ ...inputSx, minWidth: 150 }}
          size="small"
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="PENDING">Pending</MenuItem>
          <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
          <MenuItem value="COMPLETED">Completed</MenuItem>
        </TextField>
        {(filterUserId || filterStatus) && (
          <Button
            variant="text"
            onClick={() => {
              setFilterUserId("");
              setFilterStatus("");
            }}
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              fontSize: "0.82rem",
              color: "#868e96",
              textTransform: "none",
              px: 1,
              "&:hover": { color: "#e03131", background: "transparent" },
            }}
          >
            Clear
          </Button>
        )}
        <Tooltip title="Refresh data">
          <IconButton
            onClick={fetchData}
            size="small"
            sx={{ color: "#adb5bd", ml: "auto", "&:hover": { color: TEAL } }}
          >
            <RefreshIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Paper>

      {/* ── Table ───────────────────────────────────────────────────── */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: "16px",
          boxShadow: "0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04)",
          overflow: "hidden",
          animation: "fadeUp .48s ease both",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ borderBottom: "1px solid #f1f3f5" }}>
              {[
                "User",
                "Assessment",
                "Status",
                "Score",
                "Assigned Date",
                "Submitted Date",
                "Actions",
              ].map((h) => (
                <TableCell
                  key={h}
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    color: "#868e96",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    py: 1.8,
                    border: "none",
                    background: "#fff",
                  }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  {[...Array(7)].map((_, j) => (
                    <TableCell
                      key={j}
                      sx={{ border: "none", borderBottom: "1px solid #f8f9fa" }}
                    >
                      <Skeleton variant="text" height={20} />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : assignments.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={7}
                  align="center"
                  sx={{ py: 6, border: "none" }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontFamily: FONT, color: "#868e96" }}
                  >
                    No assignments found.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              assignments.map((ass, idx) => {
                const st = STATUS_STYLE[ass.status] || STATUS_STYLE.PENDING;
                return (
                  <TableRow
                    key={ass.id}
                    sx={{
                      borderBottom: "1px solid #f8f9fa",
                      "&:last-child td": { border: "none" },
                      "&:hover": { background: "#fafbfc" },
                      transition: "background .15s",
                      animation: `fadeUp .4s ease ${idx * 0.03}s both`,
                    }}
                  >
                    <TableCell
                      sx={{
                        fontFamily: FONT,
                        border: "none",
                        py: 1.8,
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        color: "#1a1d23",
                      }}
                    >
                      {ass.user?.name || `User #${ass.user_id}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: FONT,
                        border: "none",
                        py: 1.8,
                        fontSize: "0.875rem",
                        color: "#495057",
                      }}
                    >
                      {ass.Assessment?.title ||
                        `Assessment #${ass.assessment_id}`}
                    </TableCell>
                    <TableCell sx={{ border: "none", py: 1.8 }}>
                      <Chip
                        label={st.label}
                        size="small"
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          background: st.bg,
                          color: st.color,
                          borderRadius: "6px",
                          height: 24,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: FONT,
                        border: "none",
                        py: 1.8,
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        color: "#1a1d23",
                      }}
                    >
                      {ass.score !== null ? (
                        `${ass.score}/${ass.Assessment?.max_score || 0}`
                      ) : (
                        <Typography
                          component="span"
                          sx={{
                            color: "#adb5bd",
                            fontFamily: FONT,
                            fontSize: "0.85rem",
                          }}
                        >
                          Not taken
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: FONT,
                        border: "none",
                        py: 1.8,
                        fontSize: "0.875rem",
                        color: "#868e96",
                      }}
                    >
                      {new Date(ass.assigned_at).toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: FONT,
                        border: "none",
                        py: 1.8,
                        fontSize: "0.875rem",
                        color: "#868e96",
                      }}
                    >
                      {ass.submitted_at
                        ? new Date(ass.submitted_at).toLocaleDateString(
                            "en-US",
                            { month: "short", day: "2-digit", year: "numeric" },
                          )
                        : "—"}
                    </TableCell>
                    <TableCell sx={{ border: "none", py: 1.8 }}>
                      <Button
                        size="small"
                        onClick={() => handleRevoke(ass.id)}
                        startIcon={
                          <DeleteOutlineIcon
                            sx={{ fontSize: "14px !important" }}
                          />
                        }
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 500,
                          fontSize: "0.78rem",
                          color: "#868e96",
                          border: "1px solid #dee2e6",
                          borderRadius: "7px",
                          textTransform: "none",
                          px: 1.5,
                          py: 0.4,
                          "&:hover": {
                            borderColor: "#e03131",
                            color: "#e03131",
                            background: "#fff5f5",
                          },
                        }}
                      >
                        Revoke
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
        {!loading && assignments.length > 0 && (
          <Box sx={{ px: 3, py: 1.5, borderTop: "1px solid #f1f3f5" }}>
            <Typography
              variant="caption"
              sx={{ color: "#adb5bd", fontFamily: FONT }}
            >
              Showing {assignments.length} assignment
              {assignments.length !== 1 ? "s" : ""}
            </Typography>
          </Box>
        )}
      </TableContainer>

      {/* ── Assign Modal ─────────────────────────────────────────────── */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            fontFamily: FONT,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: FONT,
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1a1d23",
            pt: 2.5,
            pb: 0.5,
          }}
        >
          Assign Assessment to Staff
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <TextField
            select
            label="Select User"
            fullWidth
            margin="dense"
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            sx={{ ...inputSx, mb: 1.5 }}
          >
            <MenuItem value="">Select a user</MenuItem>
            {staffUsers.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name} ({user.email})
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Select Assessment"
            fullWidth
            margin="dense"
            value={selectedAssessmentId}
            onChange={(e) => setSelectedAssessmentId(e.target.value)}
            sx={inputSx}
          >
            <MenuItem value="">Select an assessment</MenuItem>
            {assessments.map((ass) => (
              <MenuItem key={ass.id} value={ass.id}>
                {ass.title} (Folder: {ass.folder_id})
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
          <Button
            onClick={() => setModalOpen(false)}
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              color: "#868e96",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": { background: "#f1f3f5" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAssign}
            variant="contained"
            disabled={submitLoading}
            sx={{
              background: TEAL,
              borderRadius: "8px",
              fontFamily: FONT,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
          >
            {submitLoading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              "Assign"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssessmentReport;
